var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "imgStyle" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "80px", model: _vm.datas, size: "small" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "图片模式" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.handleModeChange },
                  model: {
                    value: _vm.datas.mode,
                    callback: function ($$v) {
                      _vm.$set(_vm.datas, "mode", $$v)
                    },
                    expression: "datas.mode",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("单行")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("轮播海报")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.datas.mode === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "轮播间隔" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 1,
                      max: 10,
                      step: 1,
                      placeholder: "轮播间隔(秒)",
                      size: "small",
                    },
                    model: {
                      value: _vm.datas.interval,
                      callback: function ($$v) {
                        _vm.$set(_vm.datas, "interval", $$v)
                      },
                      expression: "datas.interval",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#909399",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v("秒")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "图片宽度" } },
            [
              _c("el-input-number", {
                attrs: {
                  min: 0,
                  max: 750,
                  step: 1,
                  placeholder: "0 为自适应",
                  size: "small",
                },
                model: {
                  value: _vm.datas.imgWidth,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "imgWidth", $$v)
                  },
                  expression: "datas.imgWidth",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    color: "#909399",
                    "font-size": "12px",
                  },
                },
                [_vm._v("px（0 自适应）")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "图片高度" } },
            [
              _c("el-input-number", {
                attrs: {
                  min: 0,
                  max: 1000,
                  step: 1,
                  placeholder: "0 为自适应",
                  size: "small",
                },
                model: {
                  value: _vm.datas.imgHeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "imgHeight", $$v)
                  },
                  expression: "datas.imgHeight",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    color: "#909399",
                    "font-size": "12px",
                  },
                },
                [_vm._v("px（0 自适应）")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "上传图片" } }, [
            _c(
              "div",
              { staticClass: "image-list" },
              _vm._l(_vm.imageList, function (img, index) {
                return _c("div", { key: index, staticClass: "image-item" }, [
                  _c("div", { staticClass: "image-item-wrapper" }, [
                    _c("i", {
                      staticClass: "el-icon-delete-solid delete-btn",
                      on: {
                        click: function ($event) {
                          return _vm.deleteImage(index)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "image-upload-container" }, [
                      _c("input", {
                        ref: "fileInput-" + index,
                        refInFor: true,
                        staticStyle: { display: "none" },
                        attrs: { type: "file", accept: "image/*" },
                        on: {
                          change: function (event) {
                            return _vm.handleFileChange(event, index)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "upload-area" }, [
                        _c(
                          "div",
                          {
                            staticClass: "image-preview",
                            on: {
                              click: function () {
                                return _vm.handleImageClick(index)
                              },
                            },
                          },
                          [
                            img.imgSrc
                              ? _c("img", {
                                  staticClass: "preview-img",
                                  attrs: {
                                    src: _vm.resPath + img.imgSrc,
                                    alt: "图片 " + (index + 1),
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "image-placeholder" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-picture-outline",
                                    }),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("点击上传图片")]),
                                  ]
                                ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "image-config" },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "图片标题", size: "small" },
                          model: {
                            value: img.title,
                            callback: function ($$v) {
                              _vm.$set(img, "title", $$v)
                            },
                            expression: "img.title",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入外部链接地址",
                            size: "small",
                          },
                          model: {
                            value: img.http,
                            callback: function ($$v) {
                              _vm.$set(img, "http", $$v)
                            },
                            expression: "img.http",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "upload-tip" }, [
              _vm._v(
                "\n        图片格式：jpg/png，大小≤5MB，建议尺寸315px*120px，或同比例图片\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "add-btn-container" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
              on: { click: _vm.addImage },
            },
            [_vm._v("\n      添加图片\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }